const MODE_LABELS = {
  FIXED_SERVICE: "Fixed service",
  INSPECTION_FIRST: "Inspection",
};

const STATUS_LABELS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  PAUSED: "Paused",
  ARCHIVED: "Archived",
  OFF: "Off",
  ENABLED: "Enabled",
  SUSPENDED: "Suspended",
  PAYMENT_PENDING: "Payment pending",
  PRIMARY_EXPERT_PENDING: "Primary expert pending",
  OPS_ACTION_REQUIRED: "Operations action required",
  ASSIGNED: "Assigned",
  CANCELLED: "Cancelled",
  FAILED: "Failed",
  PENDING: "Pending",
  ACCEPTED: "Accepted",
  DECLINED: "Declined",
  TIMED_OUT: "Timed out",
  OPS_CONFIRMED: "Operations confirmed",
  CAPTURED: "Captured",
  NONE: "None",
  REFUND_REQUIRED: "Refund required",
  REFUND_INITIATED: "Refund initiated",
  REFUNDED: "Refunded",
  REFUND_FAILED: "Refund failed",
};

export const quickBookModeLabel = (value) => MODE_LABELS[value] || "Unknown mode";

export const quickBookStatusLabel = (value) => (
  STATUS_LABELS[value] || STATUS_LABELS[String(value || "").toUpperCase()] || "Unknown status"
);

export const positiveBookingId = (value) => (
  Number.isSafeInteger(value) && value > 0 ? value : null
);
